module.exports = __webpack_public_path__ + "media/images/iconPaginateLast__okGreen-de27810dbac74a098ccb61bc28eb2e5e.png";